// Shared countdown / stopwatch badge shown on the board corner for everyone.
// KEEP IN SYNC with the dashboard original.
import { useEffect, useState } from "react";

const format = (totalSeconds) => {
    const clamped = Math.max(0, totalSeconds);
    const minutes = Math.floor(clamped / 60);
    const seconds = Math.floor(clamped % 60);
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

const TimerOverlay = ({ timer, timeOffset, isTeacher, onStop }) => {
    const [, forceTick] = useState(0);

    useEffect(() => {
        if (!timer) return;
        const interval = setInterval(() => forceTick((n) => n + 1), 250);
        return () => clearInterval(interval);
    }, [timer]);

    if (!timer) return null;

    const serverNow = Date.now() + (timeOffset || 0);
    const elapsed = (serverNow - timer.startedAt) / 1000;
    const isCountdown = timer.mode === "countdown";
    const value = isCountdown ? timer.duration - elapsed : elapsed;
    const finished = isCountdown && value <= 0;

    return (
        <div
            style={{
                position: "absolute",
                top: 10,
                insetInlineStart: 10,
                zIndex: 6,
                display: "flex",
                alignItems: "center",
                gap: 8,
                background: finished ? "rgba(211,47,47,0.92)" : "rgba(23,32,42,0.85)",
                color: "#fff",
                borderRadius: 12,
                padding: "6px 14px",
                fontVariantNumeric: "tabular-nums",
                fontWeight: 700,
                fontSize: "1.25rem",
                direction: "ltr",
                animation: finished ? "wbTimerPulse 1s infinite" : "none",
            }}
        >
            <span style={{ fontSize: "1rem" }}>{isCountdown ? "⏳" : "⏱️"}</span>
            <span>{format(value)}</span>
            {isTeacher && (
                <button
                    type="button"
                    onClick={onStop}
                    style={{
                        border: "none",
                        background: "rgba(255,255,255,0.2)",
                        color: "#fff",
                        borderRadius: 8,
                        cursor: "pointer",
                        padding: "2px 8px",
                        fontSize: "0.85rem",
                    }}
                >
                    ✕
                </button>
            )}
            <style>{`@keyframes wbTimerPulse { 50% { opacity: 0.6; } }`}</style>
        </div>
    );
};

export default TimerOverlay;
